import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import Swal from "sweetalert2";
@Injectable({
	providedIn: "root",
})
export class SweetAlertService {
	constructor(private snackBar: MatSnackBar) {}
	public showTitleErorIcon(message) {
		return new Promise((resolve, reject) => {
			this.showNotification(
				"snackbar-danger",
				 `${message}`,
				"top",
				"right"
			);
			resolve(true)
		});
	}
	public showNotification(colorName, text, placementFrom, placementAlign) {
		this.snackBar.open(text, "", {
			duration: 2000,
			verticalPosition: placementFrom,
			horizontalPosition: placementAlign,
			panelClass: colorName,
		});
	}
	public Success(message) {
		this.showNotification(
			"snackbar-success",
		     `${message}`,
			"top",
			"right"
		);
	}
	// public Success(message) {
	// 	Swal.fire({
	// 		icon: `success`,
	// 		title: "Success...",
	// 		text: message,
	// 		focusConfirm: true,
	// 		confirmButtonColor: "#02524a ",
	// 		timer: 1500,
	// 	});
	// }
	public showConfirmDialog(entityInfo = "") {
		return new Promise((resolve, reject) => {
			Swal.fire({
				title: "Are you sure?",
				text: `You want to delete ${entityInfo}`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d12121",
				cancelButtonColor: "#ffa500",
				confirmButtonText: "Yes, delete it!",
				focusCancel:true,

			}).then((result) => {
				if (result.isConfirmed) {
					resolve(true);
				} else {
					reject(false);
				}
			});
		});
	}
}
